import React from 'react'
import { Modal } from 'semantic-ui-react'

export const haveTypeGoods = (invoices = []) => {
  return invoices.filter(i => (i.deliveryType || i.mainDeliveryType || '').toLowerCase() === 'goods').length > 0
}

export const acceptMessage = (ivSelected = [], language) => { // Popup message after submit
  var iv = {}
  if (ivSelected.length > 0) {
    iv = ivSelected[0]
  }
  
  var companyName = iv.companyName || ''
  var billingContactEmail = (iv.billingContactEmail || '')
  var lang = language || (iv.vendorCode || '').startsWith('3') ? 'en' : 'th'
  var submittedDate = new Date()

  const monthTxt = {
    en: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    th: [
      'มกราคม',
      'กุมภาพันธ์',
      'มีนาคม',
      'เมษายน',
      'พฤษภาคม',
      'มิถุนายน',
      'กรกฎาคม',
      'สิงหาคม',
      'กันยายน',
      'ตุลาคม',
      'พฤศจิกายน',
      'ธันวาคม',
      'มกราคม'
    ]
  }
  
  const billingDate = (date) => {
    if (date.getDate() > 24) {
      date.setDate(24)
      date.setMonth(date.getMonth() + 1)
    } 
    return date
  }
  
  const getYear = (lang, date) => {
    var year = date.getFullYear()
    if (lang === 'th') {
      return year < 2500 ? year + 543 : year
    } else {
      return year > 2500 ? year - 543 : year
    }
  }
  
   const getBillingCycleMonth = () => {
    var blDate = billingDate(submittedDate)
  
    return `${monthTxt[lang][blDate.getMonth()]} ${getYear(lang, blDate)}`
  }
  
  const acceptMessage = () => { // Popup message after submit
    const billingMessage = {
      en: {
        header: 'Billing',
        content: 
          <div style={{ display: 'flex', paddingLeft: '1rem', flexDirection: 'column' }}>
            <div style={{ display: 'flex', fontWeight: 'bold' }}>
              Your company has submitted billing in the month of
              <div style={{ color: 'red', fontWeight: 'bold', textDecoration: 'underline', marginLeft: '5px' }}>
                {getBillingCycleMonth()}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontWeight: 'bold' }}>Please send the Billing Cover Page and tax invoice (for goods) or invoice (for services) </div> 
              <div style={{ display: 'flex' }}>
                <div>by email to Accounting Department ({billingContactEmail}) {companyName}</div>
                <div style={{ color: 'red', fontWeight: 'bold', textDecoration: 'underline', marginLeft: '5px' }}>within 24 {getBillingCycleMonth()}</div>
              </div>
            </div>
            <div style={{ display: 'flex', marginTop: '10px' }}>
              Remark: When Accounting Department receives the billing documents after the specified date or the documents are incomplete, the company reserves the right to arrange a billing cycle in next month.
            </div>
          </div>
      }, 
      th: {
        header: 'การวางบิล',
        content: 
          <div style={{ display: 'flex', paddingLeft: '1rem', flexDirection: 'column' }}>
            <div style={{ display: 'flex', fontWeight: 'bold' }}>
              บริษัทของท่านได้วางบิลในรอบเดือน
              <div style={{ color: 'red', fontWeight: 'bold', textDecoration: 'underline', marginLeft: '5px' }}>
                {getBillingCycleMonth()}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontWeight: 'bold' }}>กรุณา Print ใบปะหน้าการวางบิล (Billing Cover Page) และนำส่งต้นฉบับใบกำกับภาษี(กรณีซื้อสินค้า) หรือต้นฉบับใบแจ้งหนี้(กรณีบริการ)</div> 
              <div style={{ display: 'flex' }}>
                <div>โดยต้องส่งเอกสารมาถึง {companyName} ภายในวันที่ </div>
                <div style={{ color: 'red', fontWeight: 'bold', textDecoration: 'underline', marginLeft: '5px' }}>24 {getBillingCycleMonth()}</div>
              </div>
            </div>
            <div style={{ display: 'flex', marginTop: '10px' }}>
              <div style={{ fontWeight: 'bold', marginRight: '5px' }}>ผู้รับ :</div>
              <div>ฝ่ายบัญชี (เอกสารประกอบการวางบิล) {companyName}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div style={{ fontWeight: 'bold', marginRight: '5px' }}>ที่อยู่ :</div>
              <div>695 หมู่ที่ 12 ต.บางแก้ว อ.บางพลี จ.สมุทรปราการ 10540</div>
            </div>
            <div style={{ display: 'flex', marginTop: '10px' }}>
              หมายเหตุ: กรณีที่บริษัทได้รับเอกสารหลังวันที่กำหนดหรือเอกสารไม่ครบถ้วน บริษัทขอสงวนสิทธิ์จัดเป็นรอบการ<div style={{ fontWeight: 'bold', textDecoration: 'underline' }}>วางบิลของเดือนถัดไป</div>
            </div>
          </div>
      }
    }
  
    return (
      <React.Fragment>
        <Modal.Header>{billingMessage[lang].header}</Modal.Header>
        <Modal.Content>{billingMessage[lang].content}</Modal.Content>
      </React.Fragment>
    )
  }

  return acceptMessage()
}